import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { API_SCORECARD } from 'constants/api';
import { Scorecard } from 'store/interfaces';
import { scorecardsTexts } from 'i18n';
import { showToast } from '../../toast';

export const createScorecard = createAsyncThunk<
  Scorecard,
  {
    reviewCycleId: number;
    sourceScorecardId?: number;
  }
>('scorecards/create', async ({ reviewCycleId, sourceScorecardId }, thunkAPI) =>
  api.axios
    .post(API_SCORECARD, {
      reviewCycleId,
      ...(sourceScorecardId ? { sourceScorecardId } : {}),
    })
    .then((res) => res.data)
    .catch((e) => {
      thunkAPI.dispatch(
        showToast({
          severity: 'error',
          message: scorecardsTexts.createScorecardError,
        }),
      );

      return thunkAPI.rejectWithValue(e.response?.data);
    }),
);
